import React from 'react';
import { StoreTextSpotModule } from '~/lib/data-contract';
import {
    StyledStoreWrapper,
    StyledTextSpotContainer,
} from '~/features/find-store/components/StoreMap/components/styled';

type StoreTextSpotProps = StoreTextSpotModule;

export const StoreTextSpot = ({ text, spacingBottom, spacingTop, border }: StoreTextSpotProps) => {
    return (
        <StyledStoreWrapper spacingBottom={spacingBottom} spacingTop={spacingTop} border={border}>
            <StyledTextSpotContainer>
                {text && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: text,
                        }}
                    />
                )}
            </StyledTextSpotContainer>
        </StyledStoreWrapper>
    );
};
